module.exports = __webpack_public_path__ + "static/media/block-2-item-3.eb41b87d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-2-item-3.jpg
// module id = 1253
// module chunks = 270